import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import isNumber from 'lodash/isNumber'

import InventoryIcon from '@/checkout-instore-legacy/components/Commons/Icons/Inventory'
import { skeletonLoading } from './utils'

interface InStoreStockLabelProps {
  quantity: number
  loading: boolean
}

const InStoreStockLabel: FC<InStoreStockLabelProps> = ({
  quantity,
  loading,
}) => {
  if (!isNumber(quantity)) {
    return null
  }

  if (loading) {
    return skeletonLoading
  }

  const icon = (
    <span className="mr2">
      <InventoryIcon color="currentColor" />
    </span>
  )

  switch (quantity) {
    case 0:
      return (
        <div
          className="c-muted-2 truncate strike"
          data-testid="in-store-stock-label"
        >
          {icon}
          <span className="t-small" data-testid="in-store-stock-label-zero">
            <FormattedMessage id="product.stock.inStore.zero" />
          </span>
        </div>
      )
    case 1:
      return (
        <div className="b c-danger truncate" data-testid="in-store-stock-label">
          {icon}
          <span className="b t-small " data-testid="in-store-stock-label-one">
            <FormattedMessage id="product.stock.inStore.one" />
          </span>
        </div>
      )
    default:
      return (
        <div
          className="c-on-base lh-copy truncate"
          data-testid="in-store-stock-label"
        >
          {icon}
          <span data-testid="in-store-stock-label-many" className="b">
            {quantity}
          </span>
          <span>{` `}</span>
          <span className="t-small ">
            <FormattedMessage id="product.stock.inStore.many" />
          </span>
        </div>
      )
  }
}

export default InStoreStockLabel
